import React from 'react';
import { HelpCards } from 'shared/components/HelpCards';
import { labels } from './labels';

export const PublicCreditNoteHelpCards = () => {
  const helpArticles = [...labels.default];

  return <HelpCards helpItems={helpArticles} />;
};
